import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import Config from '../../Core/Config.js';
import {framework} from 'saffroncodejs';
import Axios from 'axios';
import BimeManager from '../../Core/BimeManager';
import UserManager from '../../Core/UserManager';
import {libs,ui} from 'saffroncodejs';
var PageManager = framework.PageManager ;
class ASB extends React.Component {
    
    constructor(props) {
        super(props);
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);
        this.state = {
            isLoading:true,
            activeTab: 1,
            data:[{"Bid":833,"FullBno":"94/05/540/3791/1200028","BNSodurDate":"1394/07/20","AgentCodeText":"شعبه يزد کد 540","CodesodurText":"مجتبي دهقاني فيروزآبادي کد 3791","BimeGozarText":"جناب آقاي هادي ميرشمسي كد 2183770","CodeMelli":"4420042214","BGAddress":"يزد خ انقلاب بلوار مشير 24 متري محمود آباد پ 208","NegahdariAddress":"يزد، شاهديه، دشت اماميه، بعد از کارخانه روغن، کوچه روبروي آذين موزائيک، باشگاه چهلستون","Moddat":365,"BeginDate":"1394/07/20","EndDate":"1395/07/20","BimeSubject":null,"Franshiz":"30 درصد ارزش اسب","HBText_WithMoneyUnit":"8,400,000 ريال","HBLiteralText":"هشت ميليون و چهارصد هزار ريال ","HBKolText_WithMoneyUnit":"9,156,000 ريال","HBWithAvarezLitText":"نه ميليون و يكصد و پنجاه و شش هزار ريال ","AfzoodehMaliatText_WithMoneyUnit":"504,000 ريال","ShahrdariAvarezText_WithMoneyUnit":"252,000 ريال","HorseInfo":[{"BID":833,"HorseName":"نادرخان آبادان","HorseId":"0","MicroChipNum":"985170002926333","GozarNameID":"0","LineAgeText":"عرب","ColorText":"كرنگ","Age":"5 سال و 8 ماه","HorseFName":"ريچارد عقيلي","HorseMName":"زهره هلاکو","HorseIdSodurDate":"1391/10/15","SarmayeText_WithoutMoneyUnit":"200,000,000","SarmayeText_WithMoneyUnit":"200,000,000 ريال","ValidUser":"هادي ميرشمسي، مهدي سلطاني","JensiatKindText":"نريان","UsageTypeText":"مسابقه اي کورسي"}],"PusheshKind":[{"Bid":833,"BNPusheshTxt":"پوشش تلف  بعلت بيماري"},{"Bid":833,"BNPusheshTxt":"پوشش تلف و نقص عضو در اثر حمل و نقل"}],"Endorsement":[],"Reshte":95,"Bill":null,"ErrorMessage":null}]
        }
        this.state.data = {} ;
        
        this.state.btns=[];
       
       this.loadDetail();
            
    }

    encodeSodurId(encodedId)
    {
        return encodedId;
    }

    componentWillReceiveProps(props)
    {
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);

        this.loadDetail();
    }

    loadDetail()
    {
        Axios.post(BimeManager.reactRedirectDomain,
            BimeManager.makeBody("/NovinInsuranceServices/Hr/api/Hr/PolicyInfo",
           
                {id: this.currentSodurId, codeMelli:  UserManager.MelliCode()}
            ),
            BimeManager.header())
            .then((result)=>{
                
                this.setState({data:result.data,isLoading:false})
                console.log("Asb : ",this.state.data);
            })
            .catch((error) => { alert(error) })   
    }
    pagechange(bid,reshte) {
        
        PageManager.changePage(Config.p_pardakhtman,[bid,reshte]);
    }
    render() {
        return (

            <div>
               <Row>
                    <Col sm="12" className="alignRight title">
                        <h4>اسب</h4>
                    </Col>
                </Row>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 1 }}
                            onClick={() => { this.setState({activeTab:1}) }}>
                            جزئیات
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 2 }}
                            onClick={() => { this.setState({activeTab:2}) }}>
                           الحاقیه
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 3 }}
                            onClick={() => { this.setState({activeTab:3}) }}>
                           مشخصات اسب مورد نظر
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 4 }}
                            onClick={() => { this.setState({activeTab:4}) }}>
                           خطرات تحت پوشش
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink onClick={() => {this.pagechange(this.currentSodurId,this.state.data.Reshte)}}>
                            پرداخت شده ها
                        </NavLink>
                    </NavItem>
                </Nav>
               

{ (!this.state.isLoading)?(
        
         
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={1}>
                        <Row>
                            <Col sm="12">
                                <div className="container ListOfList">
                                    <Row>
                                        <Col sm="12"><span className="bold-head">کد رایانه بیمه نامه:</span>{this.state.data.Bid}</Col>
                                        <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{this.state.data.FullBno}</Col>
                                        <Col sm="12"><span className="bold-head">واحد معرف:</span>{this.state.data.AgentCodeText}</Col>
                                        <Col sm="12"><span className="bold-head">واحد صدور:</span>{this.state.data.CodesodurText}</Col>
                                        <Col sm="12"><span className="bold-head">تاریخ صدور:</span>{this.state.data.BNSodurDate}</Col>
                                        <Col sm="12"><span className="bold-head">نام بيمه گذار(مالك اسب):</span>{this.state.data.BimeGozarText}</Col>
                                        <Col sm="12"><span className="bold-head">کد ملی:</span>{this.state.data.CodeMelli}</Col>
                                        <Col sm="12"><span className="bold-head">مدت اعتبار بیمه نامه:</span>{this.state.data.Moddat}</Col>
                                        <Col sm="12"><span className="bold-head">تاریخ شروع:</span>{this.state.data.BeginDate}</Col>
                                        <Col sm="12"><span className="bold-head">تاریخ پایان:</span>{this.state.data.EndDate}</Col>
                                        <Col sm="12"><span className="bold-head">موضوع بیمه:</span>{this.state.data.BimeSubject}</Col>
                                        <Col sm="12"><span className="bold-head">فرانشیز:</span>{this.state.data.Franshiz}</Col>
                                        <Col sm="12"><span className="bold-head">حق بیمه:</span>{this.state.data.HBText_WithMoneyUnit}</Col>
                                        <Col sm="12"><span className="bold-head">حق بیمه به حروف:</span>{this.state.data.HBLiteralText}</Col>
                                        <Col sm="12"><span className="bold-head">مبلغ قابل پرداخت به عدد:</span>{this.state.data.HBKolText_WithMoneyUnit}</Col>
                                        <Col sm="12"><span className="bold-head">مبلغ قابل پرداخت به حروف:</span>{this.state.data.HBWithAvarezLitText}</Col>
                                        <Col sm="12"><span className="bold-head">مالیات بر ارزش افزوده:</span>{this.state.data.AfzoodehMaliatText_WithMoneyUnit}</Col>
                                        <Col sm="12"><span className="bold-head">عوارض شهرداری:</span>{this.state.data.ShahrdariAvarezText_WithMoneyUnit}</Col>
                                       
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </TabPane>

                    <TabPane tabId={2}>
                        <Row>
                            <Col sm="12">
                                <div className="container ListOfList">
                                    <Row>
                                        {
                                            //alert('bill***'+this.state.data.Bill)
                                          (this.state.data.Endorsement)?  this.state.data.Endorsement.map((elhaghie)=>{
                                            return <div className="border-List">
                                                           
                                                            <Col sm="12"><span className="bold-head">کد رایانه بیمه نامه:</span>{elhaghie.BID}</Col>
                                                            <Col sm="12"><span className="bold-head">نوع بیمه نامه:</span>{elhaghie.BimeKind}</Col>
                                                            <Col sm="12"><span className="bold-head">شماره الحاقیه:</span>{elhaghie.ElhNo}</Col>
                                                            <Col sm="12"><span className="bold-head">تاریخ صدور:</span>{elhaghie.SodurDate}</Col>
                                                            <Col sm="12"><span className="bold-head">تاریخ اعمال:</span>{elhaghie.ActiveDate}</Col>
                                                            <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{elhaghie.FullBno}</Col>
                                                            <Col sm="12"><span className="bold-head">شماره ردیف سالانه:</span>{elhaghie.Radif}</Col>
                                                            <Col sm="12"><span className="bold-head">نماینده/کارگزار:</span>{elhaghie.AgentCodeText}</Col>
                                                            <Col sm="12"><span className="bold-head">واحد صدور:</span>{elhaghie.CodesodurText}</Col>
                                                            <Col sm="12"><span className="bold-head">بیمه گذار:</span>{elhaghie.BimegozarText}</Col>
                                                            <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{elhaghie.sharh}</Col>
                                                            <Col sm="12"><span className="bold-head">مالیات بر ارزش افزوده:</span>{libs.StringFunctions.currancyPrint(elhaghie.AfzoodehMaliat)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">عوارض شهرداری:</span>{libs.StringFunctions.currancyPrint(elhaghie.ShahrdariAvare)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه اضافی:</span>{libs.StringFunctions.currancyPrint(elhaghie.EzafiHB)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه اضافی با مالیات:</span>{libs.StringFunctions.currancyPrint(elhaghie.EzafiHBTotal)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه برگشتی:</span>{libs.StringFunctions.currancyPrint(elhaghie.BargashtiHB)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه برگشتی با مالیات:</span>{libs.StringFunctions.currancyPrint(elhaghie.BargashtiHBTotal)+('ریال')}</Col>
                                                           <br/>
                                                           </div>
                                                
                                            }):''
                                        }
                                            
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </TabPane>


                     <TabPane tabId={3}>
                        <Row>
                            <Col sm="12">
                                <div className="container ListOfList">
                                    <Row>
                                        {
                                            //alert('bill***'+this.state.data.Bill)
                                          (this.state.data.HorseInfo)?  this.state.data.HorseInfo.map((moshakhasatasb)=>{
                                            return <div className="border-List">
                                                           
                                        <Col sm="12"><span className="bold-head">نام اسب:</span>{moshakhasatasb.HorseName}</Col>
                                        <Col sm="12"><span className="bold-head">شماره شناسنامه:</span>{moshakhasatasb.HorseId}</Col>
                                        <Col sm="12"><span className="bold-head">شماره میکرو چیپ:</span>{moshakhasatasb.MicroChipNum}</Col>
                                        <Col sm="12"><span className="bold-head">شماره گذرنامه:</span>{moshakhasatasb.GozarNameID}</Col>
                                        <Col sm="12"><span className="bold-head">سن اسب:</span>{moshakhasatasb.Age}</Col>
                                        <Col sm="12"><span className="bold-head">نژاد اسب:</span>{moshakhasatasb.LineAgeText}</Col>
                                        <Col sm="12"><span className="bold-head">رنگ اسب:</span>{moshakhasatasb.ColorText}</Col>
                                        <Col sm="12"><span className="bold-head">نام پدر:</span>{moshakhasatasb.HorseFName}</Col>
                                        <Col sm="12"><span className="bold-head">نام مادر:</span>{moshakhasatasb.HorseMName}</Col>
                                        <Col sm="12"><span className="bold-head">تاريخ صدور شناسنامه:</span>{moshakhasatasb.HorseIdSodurDate}</Col>
                                        <Col sm="12"><span className="bold-head">ارزش مورد بیمه:</span>{moshakhasatasb.SarmayeText_WithoutMoneyUnit}</Col>
                                        <Col sm="12"><span className="bold-head">نام استفاده كننده مجاز:</span>{moshakhasatasb.ValidUser}</Col>
                                        <Col sm="12"><span className="bold-head">جنسیت:</span>{moshakhasatasb.JensiatKindText}</Col>
                                        <Col sm="12"><span className="bold-head">نوع کاربری اسب:</span>{moshakhasatasb.UsageTypeText}</Col>
                                        
                                       
                                                           <br/>
                                                           </div>
                                                
                                            }):''
                                        }
                                            
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </TabPane>

                
                <TabPane tabId={4}>
                        <Row>
                            <Col sm="12">
                                <div className="container ListOfList">
                                    <Row>
                                        {
                                            //alert('bill***'+this.state.data.Bill)
                                          (this.state.data.PusheshKind)?  this.state.data.PusheshKind.map((khatar)=>{
                                            return <div className="border-List">
                                                           
                                        <Col sm="12"><span className="bold-head">نوع پوشش:</span>{khatar.BNPusheshTxt}</Col>
                                                           <br/>
                                                           </div>
                                                
                                            }):''
                                        }
                                            
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </TabPane>


                </TabContent>):(<ui.Preloader />)
                
            
            
         }
         </div>
        );
    }
}


export default ASB;


// WEBPACK FOOTER //
// ./src/components/ListCollapse/ASB.js